import { PROVISIONING_STEPS } from '@zentera/shared';

export const AUDIT_ACTION_LABELS: Record<string, string> = {
  'auth.login': 'Entrou no painel',
  'auth.login_failed': 'Tentativa de login falhou',
  'auth.logout': 'Saiu do painel',
  'auth.mfa_verified': 'Concluiu verificação em duas etapas',
  'auth.mfa_failed': 'Código de verificação inválido',
  'auth.mfa_enabled': 'Ativou verificação em duas etapas',
  'auth.password_changed': 'Alterou a senha',
  'auth.session_revoked': 'Encerrou uma sessão',
  'provider.created': 'Cadastrou provedor',
  'provider.updated': 'Atualizou dados do provedor',
  'provisioning.step_updated': 'Atualizou etapa de implantação',
  'instance.registered': 'Registrou VPS',
  'instance.updated': 'Atualizou dados da VPS',
  'instance.token_rotated': 'Rotacionou token da instância',
  'instance.operation_requested': 'Solicitou operação na instância',
  'agent.version_created': 'Criou versão de agente',
  'agent.version_published': 'Publicou versão de agente',
  'integration.updated': 'Alterou integração de ERP',
  'usage.budget_updated': 'Alterou orçamento de IA',
  'user.created': 'Criou usuário',
  'user.updated': 'Alterou usuário',
  'user.mfa_reset': 'Redefiniu MFA de usuário',
  'alert.acknowledged': 'Reconheceu alerta',
  'release.registered': 'Registrou versão da aplicação',
  'instance.install_code_created': 'Gerou código de instalação',
  'instance.install_script_downloaded': 'Script de instalação baixado',
  'provisioning.auto_verified': 'Etapas verificadas pelo agente',
  'knowledge.global_created': 'Criou artigo de conhecimento global',
  'knowledge.global_updated': 'Editou artigo de conhecimento global',
  'knowledge.global_published': 'Publicou artigo de conhecimento global',
  'knowledge.global_unpublished': 'Retirou artigo de conhecimento global',
  'knowledge.global_deleted': 'Removeu artigo de conhecimento global',
};

export const auditLabel = (action: string) => AUDIT_ACTION_LABELS[action] ?? action;

export const stepLabel = (key: string | null | undefined) =>
  PROVISIONING_STEPS.find((s) => s.key === key)?.label ?? key ?? '—';

export const PROFILE_LABELS: Record<string, string> = {
  triage: 'Triagem',
  support: 'Suporte técnico',
  finance: 'Financeiro',
  sales: 'Comercial',
  general: 'Atendimento geral',
};
